<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: "video",
    }
</script>

<style lang="scss" scoped>

</style>